import axios from 'axios';
import useAuthStore from '../store/authStore';

const API_URL = 'https://backend.ysskytravel.com/api';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const { token } = useAuthStore.getState();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
